import { Component } from 'react';
import { intersection, map } from 'ramda';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TagInput from '../tag-input/TagInput.jsx';
import { POI_FIELDS } from '../constants';
import s from './TagEditor.module.scss';

const MAX_DISPLAY_TAGS = 10;

export default class TagEditor extends Component {
    static propTypes = {
        allTags: PropTypes.array,
        changedFields: PropTypes.arrayOf(PropTypes.string),
        disabled: PropTypes.bool,
        displayTags: PropTypes.arrayOf(PropTypes.string),
        onUpdatePoiField: PropTypes.func,
        tags: PropTypes.arrayOf(PropTypes.string),
    };

    static defaultProps = {
        allTags: [],
        changedFields: [''],
        disabled: false,
        displayTags: [],
        onUpdatePoiField: () => {},
        tags: [],
    };

    tagCountLabel = count => {
        const tagWord = count === 1 ? 'tag' : 'tags';
        return `${count} ${tagWord} total`;
    };

    renderTitle = (title, fields) => {
        const { changedFields } = this.props;
        const isDirty = intersection(fields, changedFields).length > 0;
        const classes = classNames(s.title, { [s.dirty]: isDirty });
        return <div className={classes}>{title}</div>;
    };

    render() {
        const { displayTags, tags, allTags, disabled } = this.props;
        const tooMany = displayTags.length >= MAX_DISPLAY_TAGS;
        const suggestions = map(tag => ({ id: tag.value, text: tag.label }), allTags);

        return (
            <div className={s.tagEditor}>
                <div className={s.visibleTags}>
                    {this.renderTitle(`VISIBLE TAGS (${displayTags.length})`, [POI_FIELDS.DISPLAY_TAGS])}
                    <div className={s.subtitle}>These tags are seen through the search feature, API interface, and the POI window.</div>
                    <TagInput
                        suggestions={suggestions}
                        tags={displayTags}
                        onChange={values => {
                            this.props.onUpdatePoiField('displayTags', values);
                        }}
                        maxItems={MAX_DISPLAY_TAGS}
                        disabled={disabled}
                    />
                    <div className={s.tagNotes}>
                        <div className={s.tagLimitNote}>Note: 10 max</div>
                        {tooMany && <div className={s.tagLimitError}>Tag limit reached</div>}
                    </div>
                </div>

                <div className={s.hiddenTags}>
                    {this.renderTitle(`HIDDEN TAGS (${tags.length})`, [POI_FIELDS.TAGS])}
                    <div className={s.subtitle}>These tags are seen through the search feature and API interface but do not appear on the POI window.</div>
                    <TagInput
                        suggestions={suggestions}
                        tags={tags}
                        onChange={values => {
                            this.props.onUpdatePoiField('tags', values);
                        }}
                        disabled={disabled}
                        maxItems={Number.MAX_SAFE_INTEGER}
                    />
                    <div className={s.tagLimitNote}>Note: No tag limit</div>
                </div>
            </div>
        );
    }
}
